import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { PerfilService } from 'src/app/perfil/perfil.service';
import { TipoFuncionalidade, TipoValidacaoCadastral, ValidacaoCadastroModalComponent, ValidacaoCadastroModalData } from 'src/app/shared/components/validacao-cadastro-modal/validacao-cadastro-modal.component';
import { LoaderService } from 'src/app/shared/loader/loader.service';
import { ModalWrapperData } from 'src/app/shared/models/modal-wrapper-data.model';
import PerfilCliente from 'src/app/shared/models/perfil-cliente.model';
import { BaseModalService } from 'src/app/shared/services/base-modal.service';
import { ToastService } from 'src/app/shared/toast';

export type SelectedConfirmTokenMethod = {
  method: 'PHONE' | 'EMAIL';
}

@Component({
  selector: 'app-verification-method',
  templateUrl: './verification-method.component.html',
  styleUrls: ['./verification-method.component.scss']
})
export class VerificationMethodComponent implements OnInit {

  subscriptions = new Subscription();
  clientePerfil = new PerfilCliente();
  modalValidacaoRef: MatDialogRef<any>;
  TipoValidacaoCadastral = TipoValidacaoCadastral;

  @Input()
  isInternal = false;

  @Input()
  userInfo: { email: string; phone: string; }

  @Output()
  methodSelection: EventEmitter<TipoValidacaoCadastral> = new EventEmitter<TipoValidacaoCadastral>();

  constructor(
    private router: Router,
    private perfilService: PerfilService,
    private loaderService: LoaderService,
    private baseModalService: BaseModalService,
  ) { }

  ngOnInit(): void {
    this.buscarClientePerfil();
  }

  async buscarClientePerfil() {
    if (this.isInternal) {
      await this.fetchClientProfileInternal();
    }
  }

  private async fetchClientProfileInternal() {
    try {
      this.loaderService.start();
      const clientePerfil = await this.perfilService.getPerfil();
      if (clientePerfil) {
        this.clientePerfil = clientePerfil;
        if (this.clientePerfil.celular) {
          this.clientePerfil.celular = this.clientePerfil.celular.substring(3);
        }
      }
    } catch (response) {
    } finally {
      this.loaderService.stop();
    }
  }

  async selectVerificationMethod(tipo: TipoValidacaoCadastral) {
    this.methodSelection.emit(tipo);
  }

  private async selectVerificationMethodInternal(tipo: TipoValidacaoCadastral) {
    const initialValue = tipo === TipoValidacaoCadastral.PHONE ? this.clientePerfil.celular : this.clientePerfil.email;

    const data: ModalWrapperData<ValidacaoCadastroModalData> = {
      title: 'Verificação de segurança',
      component: ValidacaoCadastroModalComponent,
      config: { disableClose: true, autoFocus: false },
      data: {
        tipo,
        initialValue,
        funcionalidade: TipoFuncionalidade.VALIDACAO,
      }
    };

    this.modalValidacaoRef = this.baseModalService.showModal(data);

    const modalResponse: { valido: boolean; showConfirmationModal?: boolean; } = await this.modalValidacaoRef.afterClosed().toPromise();

    if (modalResponse.valido) {
      this.router.navigate(['portal/perfil/alterar/senha'], { state: { isValidationAllowed: true } });
    } else if (modalResponse.showConfirmationModal) {
      this.router.navigate(['portal/perfil']);
    }
  }

  async showUpdatePhoneModal() {
    const data: ModalWrapperData<ValidacaoCadastroModalData> = {
      title: 'Alterar celular',
      component: ValidacaoCadastroModalComponent,
      config: { disableClose: true, autoFocus: true, width: '100%', maxWidth: '643px' },
      data: {
        tipo: TipoValidacaoCadastral.PHONE,
        funcionalidade: TipoFuncionalidade.CADASTRO,
      }
    };

    this.modalValidacaoRef = this.baseModalService.showModal(data);

    const modalResponse: { valido: boolean, showConfirmationModal?: boolean } = await this.modalValidacaoRef.afterClosed().toPromise();

    if (modalResponse.valido) {
      this.buscarClientePerfil();
    }
  }

  async goToAccountRecovery() {
    this.router.navigate(['recuperar-senha/confirmar-dados']);
  }

  async showUpdateEmailModal() {
    const data: ModalWrapperData<ValidacaoCadastroModalData> = {
      title: this.clientePerfil.email ? 'Alterar e-mail' : 'Adicionar e-mail',
      component: ValidacaoCadastroModalComponent,
      config: { disableClose: true, autoFocus: true, width: '100%', maxWidth: '643px' },
      data: {
        tipo: TipoValidacaoCadastral.EMAIL,
        funcionalidade: this.clientePerfil.email ? TipoFuncionalidade.ALTERACAO : TipoFuncionalidade.CADASTRO,
        initialValue: this.clientePerfil.email,
      }
    };

    this.modalValidacaoRef = this.baseModalService.showModal(data);

    const modalResponse: { valido: boolean, showConfirmationModal?: boolean } = await this.modalValidacaoRef.afterClosed().toPromise();

    if (modalResponse.valido) {
      this.buscarClientePerfil();
    }
  }
}
